import { MutationTree, ActionTree, GetterTree } from "vuex";
import { Plan, Balance, ETF, Statistics, Profile } from "@foxone/api/src/models/hfox";
import { BOX_ASSET_ID } from "hfox/constants";

export const state = () => ({
  plans: [],
  etfs: [],
  balance: null,
  statistics: null,
  profile: null,
  loading: false,
  toushi_bind: false
});

export type HfoxState = ReturnType<
  () => {
    plans: Plan[];
    etfs: ETF[];
    balance: Balance;
    statistics: Statistics;
    loading: boolean;
    profile: Profile;
    toushi_bind: boolean;
  }
>;

export const getters: GetterTree<HfoxState, {}> = {
  getActivePlans(state) {
    return state.plans.filter(plan => ["ACTIVE", "MAINTAIN"].includes(plan.status));
  },
  getStopPlans(state) {
    return state.plans.filter(plan => plan.status === "STOP");
  },
  getBalance(state) {
    return Number(state.balance?.balance ?? 0);
  },
  getPlanById(state) {
    return (id: string) => {
      return state.plans.find(p => p.id + "" === id);
    };
  }
};

export const mutations: MutationTree<HfoxState> = {
  SET_PLANS(state, plans) {
    state.plans = plans;
  },
  SET_ETFS(state, etfs) {
    state.etfs = etfs;
  },
  SET_BALANCE(state, balance) {
    state.balance = balance;
  },
  SET_STATISTICS(state, data) {
    state.statistics = data;
  },
  SET_LOADING(state, value) {
    state.loading = value;
  },
  SET_PROFILE(state, data) {
    state.profile = data;
  },
  SET_TOUSHI_BIND_STATE(state, value) {
    state.toushi_bind = value;
  }
};

export const actions: ActionTree<HfoxState, {}> = {
  async loadPlans({ commit }) {
    const plans = await this.$api.hfox.getMyPlans();
    commit("SET_PLANS", plans);
  },
  async loadEtfs({ commit }) {
    const etfs = await this.$api.hfox.getEtfs();
    commit("SET_ETFS", etfs);
  },
  async loadBalance({ commit }) {
    const balance = await this.$api.hfox.getBalance();
    commit("SET_BALANCE", balance);
  },
  async loadStatistics({ commit }) {
    const data = await this.$api.hfox.getStatistics();
    commit("SET_STATISTICS", data);
  },
  async loadProfile({ commit }) {
    const data = await this.$api.hfox.getProfile();
    commit("SET_PROFILE", data);
  },
  async loadToushiBindState({ commit }) {
    const data = await this.$api.hfox.checkToushiBind();
    commit("SET_TOUSHI_BIND_STATE", data.bound);
  },
  async loadHfoxData({ dispatch }) {
    try {
      await Promise.all([
        dispatch("loadBalance"),
        dispatch("loadPlans"),
        dispatch("loadEtfs"),
        dispatch("loadStatistics"),
        dispatch("loadProfile"),
        dispatch("loadToushiBindState")
      ]);
    } catch (error) {
      console.log(error);
    }
  },
  removeHfoxData({ commit }) {
    commit("SET_PLANS", []);
    commit("SET_ETFS", []);
    commit("SET_BALANCE", null);
    commit("SET_STATISTICS", null);
    commit("SET_PROFILE", null);
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
